import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext.jsx';
import { createEntry } from '../lib/bibliography.js';
import EntryForm from '../components/bibliography/EntryForm.jsx';
import BookImporter from '../components/bibliography/BookImporter.jsx';

export default function BibliographyNew() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user, profile, isAdmin, isActive } = useAuth();
  const [busy, setBusy] = useState(false);
  const [submitted, setSubmitted] = useState(null);

  if (!isActive) {
    return (
      <div className="mx-auto max-w-2xl px-8 pb-20 pt-32">
        <div className="cta-box">
          <h1 className="cta-title">{t('bibliography.form.notActiveTitle')}</h1>
          <p className="cta-body">{t('bibliography.form.notActiveBody')}</p>
        </div>
      </div>
    );
  }

  if (submitted) {
    return (
      <div className="mx-auto max-w-2xl px-8 pb-20 pt-32">
        <div className="cta-box">
          <div className="section-label">{isAdmin ? t('bibliography.form.publishedLabel') : t('bibliography.form.submittedLabel')}</div>
          <h1 className="cta-title">{submitted.title}</h1>
          <p className="cta-body">
            {isAdmin
              ? t('bibliography.form.publishedBody')
              : t('bibliography.form.submittedBody')}
          </p>
          <div className="flex flex-wrap items-center justify-center gap-3">
            <button type="button" className="btn-ghost" onClick={() => setSubmitted(null)}>
              {t('bibliography.form.addAnother')}
            </button>
            <button type="button" className="btn-primary" onClick={() => navigate('/bibliography')}>
              {t('bibliography.form.backToBibliography')}
            </button>
          </div>
        </div>
      </div>
    );
  }

  async function handleSubmit(form) {
    setBusy(true);
    try {
      const created = await createEntry(form, { authorId: user.id, asAdmin: isAdmin });
      setSubmitted(created);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="mx-auto max-w-3xl px-6 pb-20 pt-28">
      <header className="mb-8">
        <div className="section-label">{t('bibliography.form.newLabel')}</div>
        <h1 className="font-serif text-3xl font-semibold text-cream">
          {t('bibliography.form.newHeading')}
        </h1>
        <p className="mt-2 text-sm text-ink-secondary">
          {isAdmin
            ? t('bibliography.form.newSubheadingAdmin')
            : t('bibliography.form.newSubheadingCollaborator')}
        </p>
      </header>

      <BookImporter asAdmin={isAdmin} authorId={user.id} />

      <div className="mb-6 flex items-center gap-3">
        <span className="h-px flex-1 bg-white/10" />
        <span className="text-xs uppercase tracking-[0.12em] text-ink-muted">
          {t('bibliography.import.manualDivider')}
        </span>
        <span className="h-px flex-1 bg-white/10" />
      </div>

      <EntryForm
        enableAutofill
        showAnnounce
        submitLabel={
          isAdmin ? t('bibliography.form.publish') : t('bibliography.form.submitForReview')
        }
        onSubmit={handleSubmit}
        onCancel={() => navigate('/bibliography')}
        busy={busy}
      />
    </div>
  );
}
